'use strict';

import $ from 'jquery';
import 'jquery-match-height';

export default class FeaturedLinks {
  constructor() {
    let $featuredItem = $('.featured-links__item');
    let $featuredCard = $('.featured-card', $featuredItem);
    let $featuredDesc = $('.featured-card-desc', $featuredItem);

    $featuredItem.matchHeight();

    $featuredCard.hover(
      function() {
          $( this ).addClass('is-hover');
          // $featuredDesc.slideUp();
      }, function() {
          $( this ).removeClass('is-hover');
          // $featuredDesc.slideDown();
      }
    );

    $featuredCard.on('focusin', function(){
      $( this ).addClass('is-hover');
    }).on('focusout', function(){
      $( this ).removeClass('is-hover');
    });
  }
}
